module.exports = __webpack_public_path__ + "media/images/official/special_double_life_og-28ef8f847798a216fac6a395fe00cbe9.jpg";